export default __webpack_public_path__ + "static/media/ic_japan.2d901e34.svg";